"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var axios_1 = __importDefault(require("axios"));
var StringManipulater_1 = require("Utils/StringManipulater");
var VideoEmbedUrlGenerator = (function () {
    function VideoEmbedUrlGenerator() {
        var _this = this;
        this.videoProviderNames = ["YouTube", "Vimeo", "Wistia", "Brightcove", "Loom", "Vidyard"];
        this.videoProviders = makeVideoProviders();
        this.containsProviderUrl = function (rawUrl) {
            var e_1, _a;
            try {
                for (var _b = __values(Array.from(_this.videoProviders)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var urlSnippet = _c.value.urlSnippet;
                    if (lodash_1.default.includes(rawUrl, urlSnippet)) {
                        return true;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return false;
        };
        this.isIframe = function (input) {
            return lodash_1.default.includes(input, "<iframe");
        };
        this.getEmbedUrl = function (rawUrl, videoSettings) { return __awaiter(_this, void 0, Promise, function () {
            var confirmedUrl, autoplay, loop, settings, _a, _b, _c, embedUrlSnippet, urlSnippet, generateEmbedUrl;
            var e_2, _d;
            return __generator(this, function (_e) {
                if (!lodash_1.default.isString(rawUrl)) {
                    throw new Error("Video link was not valid text");
                }
                else if (rawUrl === "") {
                    throw new Error("Video link was not valid text");
                }
                else if (this.isIframe(rawUrl)) {
                    confirmedUrl = $(rawUrl).attr("src");
                    autoplay = lodash_1.default.includes(rawUrl, "autoplay");
                    loop = lodash_1.default.includes(rawUrl, "loop");
                    settings = {
                        autoplay: autoplay,
                        loop: loop,
                    };
                    return [2, this.getEmbedUrl(confirmedUrl, settings)];
                }
                else {
                    try {
                        for (_a = __values(this.videoProviders), _b = _a.next(); !_b.done; _b = _a.next()) {
                            _c = _b.value, embedUrlSnippet = _c.embedUrlSnippet, urlSnippet = _c.urlSnippet, generateEmbedUrl = _c.generateEmbedUrl;
                            if (lodash_1.default.includes(rawUrl, embedUrlSnippet)) {
                                return [2, rawUrl];
                            }
                            else if (generateEmbedUrl != null && lodash_1.default.includes(rawUrl, urlSnippet)) {
                                return [2, generateEmbedUrl(rawUrl, videoSettings)];
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    throw new Error("We currently only support videos from ".concat((0, StringManipulater_1.arrayToReadableString)(this.videoProviderNames)));
                }
                return [2];
            });
        }); };
    }
    return VideoEmbedUrlGenerator;
}());
exports.default = VideoEmbedUrlGenerator;
var extractIdSegment = function (url) {
    var parts = url.split("/");
    var lastSegment = parts[parts.length - 1];
    return lastSegment;
};
var extractParameter = function (url, parameter) {
    var re = new RegExp("(\\?|&)".concat(parameter, "\\=([^&]*)(&|$)"));
    var matches = url.match(re);
    if (matches) {
        return matches[2];
    }
    else {
        return "";
    }
};
var getUrlSuffix = function (settings, suffix) {
    if (settings === void 0) { settings = {}; }
    if (suffix === void 0) { suffix = ""; }
    var fullSuffix = [];
    if (suffix.length) {
        fullSuffix.push(suffix);
    }
    if (settings.autoplay) {
        fullSuffix.push("autoplay=1");
    }
    if (settings.loop) {
        fullSuffix.push("loop=1");
    }
    if (fullSuffix.length === 0) {
        return "";
    }
    else {
        return "?".concat(fullSuffix.join("&"));
    }
};
var makeVideoProviders = function () {
    var videoProviders = [
        {
            embedUrlSnippet: "youtube.com/embed",
            urlSnippet: "youtube.com",
            generateEmbedUrl: function (rawUrl, videoSettings) {
                var videoId = rawUrl.match(YOUTUBE_SHORT_ID_EXTRACT_REGEX)
                    ? extractYoutubeShortId(rawUrl)
                    : extractParameter(rawUrl, "v");
                return "//www.youtube.com/embed/".concat(videoId).concat(getUrlSuffix(videoSettings, "version=3&hl=en_US&rel=0&modestbranding=1&autohide=1&showinfo=0&controls=0"));
            },
        },
        {
            embedUrlSnippet: "youtube.com/embed",
            urlSnippet: "youtu.be",
            generateEmbedUrl: function (rawUrl, videoSettings) {
                var videoId = extractIdSegment(rawUrl);
                return "//www.youtube.com/embed/".concat(videoId).concat(getUrlSuffix(videoSettings, "version=3&hl=en_US&rel=0&modestbranding=1&autohide=1&showinfo=0&controls=0"));
            },
        },
        {
            embedUrlSnippet: "//player.vimeo.com/video/",
            urlSnippet: "vimeo.com",
            generateEmbedUrl: function (rawUrl, videoSettings) { return __awaiter(void 0, void 0, Promise, function () {
                var isVimeoEmbedUrl, playerPrefix, videoId, autoplay, loop, response, htmlSnippet, srcString, embedUrl, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isVimeoEmbedUrl = function (url) {
                                var parts = url.split("/");
                                var len = parts.length;
                                var allDigits = /^\d+$/.test(parts[len - 1]);
                                if (allDigits) {
                                    if (parts[len - 2] != null && parts[len - 2] === "vimeo.com") {
                                        return true;
                                    }
                                }
                                return false;
                            };
                            playerPrefix = "//player.vimeo.com/video/";
                            if (!isVimeoEmbedUrl(rawUrl)) return [3, 1];
                            videoId = extractIdSegment(rawUrl);
                            return [2, playerPrefix + videoId + getUrlSuffix(videoSettings)];
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            autoplay = (videoSettings === null || videoSettings === void 0 ? void 0 : videoSettings.autoplay) ? "&autoplay=true" : "";
                            loop = (videoSettings === null || videoSettings === void 0 ? void 0 : videoSettings.loop) ? "&loop=true" : "";
                            return [4, axios_1.default.get("https://vimeo.com/api/oembed.json?url=".concat(rawUrl).concat(autoplay).concat(loop))];
                        case 2:
                            response = _a.sent();
                            htmlSnippet = response.data.html;
                            srcString = htmlSnippet.match(/src="([^"]+)"/)[0];
                            embedUrl = srcString.substring(5, srcString.length - 1);
                            return [2, embedUrl];
                        case 3:
                            err_1 = _a.sent();
                            if (axios_1.default.isAxiosError(err_1) && err_1.response.status === 404) {
                                throw new Error("Vimeo video not found");
                            }
                            else {
                                throw new Error("Problem contacting Vimeo - please try again later");
                            }
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            }); },
        },
        {
            embedUrlSnippet: "fast.wistia.net/embed/",
            urlSnippet: "wistia.com",
            generateEmbedUrl: function (rawUrl, videoSettings) {
                var videoId = extractIdSegment(rawUrl);
                return "//fast.wistia.net/embed/iframe/".concat(videoId).concat(getUrlSuffix(videoSettings));
            },
        },
        {
            embedUrlSnippet: "//players.brightcove.net",
            urlSnippet: "//players.brightcove.net",
        },
        {
            embedUrlSnippet: "//loom.com/embed/",
            urlSnippet: "loom.com/share",
            generateEmbedUrl: function (rawUrl, videoSettings) {
                var videoId = extractIdSegment(rawUrl);
                return "https://www.loom.com/embed/".concat(videoId);
            },
        },
        {
            embedUrlSnippet: "//play.vidyard.com/watch",
            urlSnippet: "vidyard.com",
            generateEmbedUrl: function (rawUrl, videoSettings) {
                if (rawUrl.includes("<script")) {
                    throw new Error("Please add a valid video link from ".concat((0, StringManipulater_1.arrayToReadableString)(this.videoProviderNames)));
                }
                var videoId = extractIdSegment(rawUrl);
                return "https://play.vidyard.com/".concat(videoId);
            },
        },
    ];
    return videoProviders;
};
var YOUTUBE_SHORT_ID_EXTRACT_REGEX = /youtube.com\/shorts\/([A-z0-9]*)/;
var extractYoutubeShortId = function (url) {
    var regexMatch = YOUTUBE_SHORT_ID_EXTRACT_REGEX.exec(url);
    if (!regexMatch) {
        throw new Error("Given URL does not match pattern for YouTube Short URL");
    }
    var _a = __read(regexMatch, 2), _ = _a[0], id = _a[1];
    return id;
};
